import { render, staticRenderFns } from "./scroll_scrim.vue?vue&type=template&id=3f4962e6"
import script from "./scroll_scrim.vue?vue&type=script&lang=js"
export * from "./scroll_scrim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports